import { OverlayStyle } from "shared/context/overlay/types"

export function getOverlayClassName(overlayStyle?: OverlayStyle) {
  switch (overlayStyle) {
    case OverlayStyle.ACTIONS:
      return "actions-overlay"
    case OverlayStyle.CONFIRMATION:
      return "confirmation-overlay"
    case OverlayStyle.FORM:
      return "form-overlay"
    case OverlayStyle.SEARCH:
      return "search-overlay"
    case OverlayStyle.CONTENT:
      return "content-overlay"
    default:
      return ""
  }
}
